import {
  Button,
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@ais-ui/ui-core';
import { PiBoat } from 'react-icons/pi';
import React from 'react';
import { cn } from '@ais-ui/utils';
import { useTargetsOnMap } from '../TargetsOnMapContext';
import { useMapPanelContext } from '../MapPanel/MapPanelContext';
import { CENTERCOMPONENTS } from '../MapPanel/CenterComponents';
import { useLocalization } from '@ais-ui/locale-management';

interface TargetsOnMapProps {
  className?: string;
}

export const TargetsOnMap = React.memo(({ className }: TargetsOnMapProps) => {
  const { onGetTargets } = useTargetsOnMap();
  const { centerComponent, setCenterComponent } = useMapPanelContext();
  const { messages } = useLocalization();

  const onShowTargetsOnMap = async () => {
    if (centerComponent === CENTERCOMPONENTS.TARGETSONMAP) {
      setCenterComponent(CENTERCOMPONENTS.NONE);
    } else {
      setCenterComponent(CENTERCOMPONENTS.TARGETSONMAP);
      await onGetTargets();
    }
  };

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <Button
            id="targets-on-map-button"
            onClick={onShowTargetsOnMap}
            variant="outline"
            size="icon"
            className={cn(
              'flex items-center justify-center size-8 p-1 group/btn rounded-lg',
              className,
            )}
          >
            <PiBoat className="size-5 group-hover/btn:text-primary" />
          </Button>
        </TooltipTrigger>
        <TooltipContent>{messages.targetsOnMapTooltip}</TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
});

TargetsOnMap.displayName = 'TargetsOnMap';
